import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useServerFn } from "@tanstack/react-start";
import { supabase } from "@/integrations/supabase/client";
import { checkIsAdmin } from "@/lib/admin-middleware.functions";
import { AdminShell } from "@/components/admin/AdminShell";

export const Route = createFileRoute("/_authenticated")({
  head: () => ({ meta: [{ name: "robots", content: "noindex,nofollow" }] }),
  component: AuthLayout,
});

function AuthLayout() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [allowed, setAllowed] = useState(false);
  const checkAdmin = useServerFn(checkIsAdmin);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data } = await supabase.auth.getSession();
      if (!mounted) return;
      if (!data.session) {
        navigate({ to: "/login" });
        setReady(true);
        return;
      }
      try {
        const res = await checkAdmin();
        if (!mounted) return;
        if (res.isAdmin) {
          setAllowed(true);
        } else {
          await supabase.auth.signOut();
          navigate({ to: "/login" });
        }
      } catch {
        navigate({ to: "/login" });
      } finally {
        if (mounted) setReady(true);
      }
    })();
    const { data: sub } = supabase.auth.onAuthStateChange((_e, session) => {
      if (!session) navigate({ to: "/login" });
    });
    return () => { mounted = false; sub.subscription.unsubscribe(); };
  }, [navigate, checkAdmin]);

  if (!ready) return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Laddar…</div>;
  if (!allowed) return null;
  return <AdminShell />;
}

